<template>
  <v-layout row justify-center>
    <v-date-picker
        class="mx-auto"
        v-model="currentDate"
        @input="initCalendar"
        color="secondary"
        :first-day-of-week="1"
        locale="es"></v-date-picker>
    <v-flex xs12 md10>
      <div class="nx-calendar pb-5 px-1" v-if="calendar">
        <v-calendar
            class="mx-auto"
            ref="calendar"
            v-model="currentDate"
            type="4day"
            @click:date="initCalendar"
            :start="currentDate"
            locale="es-es"
            interval-count="0"
            color="secondary">
          <template v-slot:dayHeader="{ present }">
            <div class="nx-calendar-header">
              <nx-dayparting-calendar-timeline :show-hours="true"></nx-dayparting-calendar-timeline>
            </div>
          </template>
        </v-calendar>
        <div class="v-calendar-daily__body">
          <div class="v-calendar-daily__scroll-area">
            <nx-dayparting-calendar-rows @edit="editEvent"
                                         @editModule="editModule"
                                         @remove="removeEvent"
                                         :disabled="disabled"
                                         :calendar="calendar"
                                         :rows="rows"></nx-dayparting-calendar-rows>
          </div>

          <v-tooltip bottom dark v-if="!disabled">
            <template v-slot:activator="{ on }">
              <v-btn block color="primary mx-5" @click="addRow">
                <v-icon>add_circle</v-icon>
              </v-btn>
            </template>
            <span>Añadir fila</span>
          </v-tooltip>

        </div>
        <v-dialog v-model="eventWizard" persistent max-width="900px">
          <nx-dayparting-module-event-wizard ref="wizard"
                                             @close="eventWizard = false"
                                             @create="handleCreateEvent">
          </nx-dayparting-module-event-wizard>
        </v-dialog>
        <v-dialog v-model="eventEditor" persistent max-width="900px">
          <nx-dayparting-module-event-editor ref="editor"
                                             @edit="handleEditEvent"
                                             @close="eventEditor = false"></nx-dayparting-module-event-editor>
        </v-dialog>
      </div>
    </v-flex>
    <v-btn v-if="!disabled"
           @click="createEvent"
           :style="addButtonStyle"
           color="accent"
           fab fixed bottom right>
      <v-icon>add</v-icon>
    </v-btn>
    <nx-dialog-confirm
        :text="$t('message.dayparting.deleteConfirm.text')"
        :title="$t('message.dayparting.deleteConfirm.title')"
        :accept-text="$t('message.common.cancel')"
        :cancel-text="$t('message.dayparting.actions.delete')"
        accept-color="error"
        cancel-color="primary"
        ref="confirm"
    ></nx-dialog-confirm>
  </v-layout>
</template>

<script>
import { Calendar, Day } from 'dayspan';
import NxDaypartingCalendarRows from '@/modules/board/dayparting/components/CalendarRows';
import NxDaypartingCalendarTimeline from '@/modules/board/dayparting/components/CalendarTimeline';
import NxDaypartingModuleEventWizard from '@/modules/board/dayparting/components/ModuleEventWizard';
import NxDaypartingModuleEventEditor from '@/modules/board/dayparting/components/ModuleEventEditor';
import NxDialogConfirm from '@/components/dialogs/Confirm';
import { eventToSchedule } from '@/modules/board/dayparting/helpers';
import moment from 'moment';

export default {
  name: 'nx-dayparting-calendar',
  components: {
    NxDaypartingModuleEventEditor,
    NxDialogConfirm,
    NxDaypartingModuleEventWizard,
    NxDaypartingCalendarTimeline,
    NxDaypartingCalendarRows,
  },
  props: {
    rows: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    refBoard: Number,
    blockId: Number,
  },
  data() {
    return {
      eventEditor: false,
      eventWizard: false,
      currentDate: moment().format('YYYY-MM-DD'),
      intervals: {
        first: 0,
        minutes: 60,
        count: 1,
        height: 40,
      },
      calendar: null,
    };
  },
  computed: {
    addButtonStyle() {
      return {
        'margin-right': this.$store.state.app.bag ? '360px' : '0',
      };
    },
    events() {
      return this.rows.reduce((events, row) => [
        ...events,
        ...row.moduleEvents
        // Transform cms moduleEvent to calendarEvent
          .map((eventId) => {
            const event = this.$store.getters['dayparting/moduleEventById'](eventId);
            return this.moduleEventToCalendarEvent(event);
          })
          // Add row uuid to calendarEvent
          .map((calendarEvent) => {
            calendarEvent.data.row = row.uuid;
            return calendarEvent;
          }),
      ], []);
    },
  },
  methods: {
    moduleEventToCalendarEvent({ uuid, event, module }) {
      return {
        id: uuid,
        data: {
          name: module.alias,
          color: '#212976', // TODO: Hacer aleatorio el color
          moduleId: module.id,
        },
        schedule: eventToSchedule(event),
      };
    },
    createEvent() {
      this.eventWizard = true;
    },
    handleCreateEvent({ row, moduleEvent }) {
      this.$store.dispatch('dayparting/ADD_MODULE_EVENT', { row, moduleEvent });
      this.eventWizard = false;
      this.initCalendar();
    },
    editEvent(eventId) {
      const event = this.$store.getters['dayparting/moduleEventById'](eventId);
      this.$refs.editor.editEvent(event);
      this.eventEditor = true;
    },
    editModule(moduleId) {
      console.log('EDIT MODULE', moduleId);
      this.$router.push({
        name: 'composition.editor',
        params: { compositionId: moduleId },
        query: {
          refBoard: this.refBoard,
          blockId: this.blockId,
        },
      });
    },
    handleEditEvent({ uuid, event }) {
      this.$store.dispatch('dayparting/EDIT_MODULE_EVENT', { id: uuid, event });
      this.eventEditor = false;
      this.initCalendar();
    },
    async removeEvent(eventId) {
      const agree = await this.$refs.confirm.open();
      if (agree) {
        this.$store.dispatch('dayparting/REMOVE_MODULE_EVENT', eventId);
        this.initCalendar();
      }
    },
    addRow() {
      this.$store.dispatch('dayparting/ADD_ROW');
    },
    initCalendar() {
      const date = moment(this.currentDate, 'YYYY-MM-DD');
      this.calendar = Calendar.days(4, new Day(date), 0);
      this.calendar.addEvents(this.events);
      console.log('Calendar changed', this.calendar);
    },
  },
  mounted() {
    this.initCalendar();
  },
  watch: {
    events() {
      this.initCalendar();
    },
  },
};
</script>

<style lang="stylus">
.nx-calendar {
  .v-calendar-daily__scroll-area {
    overflow-y: hidden;
  }

  .nx-calendar-header {
    height: 20px;
  }

  .timeline {
    display: flex;
    flex-wrap: wrap;
    height: 100%
    border-top: #e0e0e0 1px solid;

    &__span {
      padding-left: 4px;
      text-decoration: none;
      flex: 1 0 25%;
      align-content: center;
      justify-content: center;

      &:not(:last-child) {
        border-right: #e0e0e0 1px solid;
      }
    }
  }
}
</style>
